export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'Ελληνικά'
  },
  'title': 'ΑΝΑΚΛΗΣΗ ΠΡΟΪΟΝΤΟΣ QUICKDRAWS SIMOND ALPINISM / VERTIKA',
  'homepage': {
    'notice': 'Ανάκληση Προϊόντος. Σημαντικές πληροφορίες σχετικά με την ασφάλεια και τον εξοπλισμό σας.',
    'purchaseWindow': 'Αγοράσατε ένα σετάκι αναρρίχησης ALPINISM ή/και VERTIKA μεταξύ 1ης Ιανουαρίου 2022 και 23ης Ιουλίου 2026.',
    'skus': 'Σετάκι Alpinism 11 cm (4051175 / 8589547)\nΣετάκι Alpinism 17 cm (4051176 / 8589548)\nΣυσκευασία 5 σετάκιων Alpinism (4171656 / 8608405)\nΣετάκι Vertika 11 cm (5499689 / 8935765)\nΣετάκι Vertika 17 cm (5500194 / 8935909)',
    'responsibility': 'Ο σχεδιασμός ατομικού προστατευτικού εξοπλισμού συνεπάγεται απόλυτη ευθύνη απέναντι σε όσους χρησιμοποιούν τα προϊόντα μας. Ως εκ τούτου, σας ενημερώνουμε για μια ανάκληση σχετικά με το σετάκι που είναι εξοπλισμένο με το καραμπίνερ Rocky Fil.',
    'defect': 'Εντοπίσαμε ένα ελάττωμα στο πριτσίνωμα του συρμάτινου κλείστρου σε ορισμένα καραμπίνερ. Αυτό το ελάττωμα συναρμολόγησης μπορεί να προκαλέσει σπάσιμο του συρμάτινου κλείστρου και να δημιουργήσει κίνδυνο σπασίματος του καραμπίνερ σε περίπτωση πτώσης.',
    'stopUsing': 'Ως προφύλαξη, σας παρακαλούμε να διακόψετε αμέσως τη χρήση του προϊόντος σας και να ακολουθήσετε την παρακάτω διαδικασία.'
  },
  'procedure': {
    'stopUsing': 'Σας ζητάμε, επομένως, να διακόψετε αμέσως τη χρήση αυτού του εξοπλισμού και να ελέγξετε εάν το προϊόν σας επηρεάζεται από αυτό το ελάττωμα χρησιμοποιώντας τις παρακάτω οδηγίες αντιμετώπισης προβλημάτων.',
    'title': 'Ελέγξτε τα προϊόντα σας:',
    'intro': 'Ελέγξτε ότι και οι δύο πλευρές του συρμάτινου κλείστρου παραμένουν σταθερά στερεωμένες στο καραμπίνερ:',
    'step1': 'Πάρτε το καραμπίνερ από τη μία πλευρά, τοποθετήστε τον αντίχειρά σας ανάμεσα στα δύο σύρματα (τον αντίχειρα που βρίσκεται πιο κοντά στο πριτσίνι). Πιέστε σταθερά προς τα κάτω στο καραμπίνερ.',
    'step2': 'Γυρίστε το καραμπίνερ από την άλλη πλευρά του συρμάτινου κλείστρου.'
  },
  'outcome': {
    'nok': {
      'body': 'Μετά τον έλεγχο, το συρμάτινο κλείστρο έχει χαλαρώσει: Διακόψτε αμέσως τη χρήση του προϊόντος σας και επιστρέψτε το στο πλησιέστερο κατάστημα DECATHLON. Η ομάδα μας θα φροντίσει για το ελαττωματικό σας προϊόν και θα διεκπεραιώσει αμέσως την πλήρη επιστροφή χρημάτων για αυτά τα ανακληθέντα προϊόντα.',
      'support': 'Αν χρειαστεί, η ομάδα εξυπηρέτησης πελατών μας είναι διαθέσιμη για να βρει μια εξατομικευμένη λύση και να σας καθοδηγήσει σε κάθε βήμα: help.greece@decathlon.com.'
    },
    'ok': {
      'body': 'Μετά τον έλεγχο, το συρμάτινο κλείστρο δεν βγαίνει από το περίβλημά του: Το προϊόν σας δεν επηρεάζεται από αυτό το ελάττωμα, μπορείτε να συνεχίσετε να το χρησιμοποιείτε με απόλυτη ηρεμία.'
    }
  },
  'buttons': {
    'ok': 'Το προϊόν μου είναι εντάξει',
    'nok': 'Το προϊόν μου δεν είναι εντάξει'
  }
} as const
